/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_History_This_WeekInputs */



/**
* | output |
* | --- |
* | "This week" |
*
* @param {Chat_History_This_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_history_this_week = /** @type {((inputs?: Chat_History_This_WeekInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_History_This_WeekInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette semaine")
	return /** @type {LocalizedString} */ ("This week")
});